import React from "react";
import { useNavigate } from "react-router-dom";

const DynamicWebsiteForSchools = () => {
  const navigate = useNavigate();

  return (
    <section className="menu-section-bg">
      <div className="menu-container">

        {/* ===== HEADER ===== */}
        <div className="product-subtitleBg-header">
          <h1 className="product-titleBg">Dynamic Website for Schools</h1>
          <p className="product-subtitleBg">
            Engage students, parents, and staff with a modern, responsive, and
            dynamic school website that updates in real-time with academic and
            administrative data.
          </p>
        </div>

        {/* ===== SECTION 1 ===== */}
        <div className="product-and-sol-mainsecondCard ps-two-column-grid product-sol-card">
          <div className="enrollment-image-card product-sol-card-imageBox">
            <img
              src="../images/product&soluction/Admission&Enrollment2.jpg"
              alt="School Website"
              className="ps-main-image"
            />
          </div>

          <div>
            <h2 className="product-and-sol-sectionTitle">
              Launch Your Dynamic K-12 School Website in Just 90 Days
            </h2>
            <p className="product-and-sol-section-text">
              In the digital era, your K-12 school website isn’t just a static
              brochure—it’s the heartbeat of your community, a 24/7 gateway for
              enrollment, engagement, and education.
            </p>

            <p className="product-and-sol-section-text">
              Why invest in a dynamic K-12 school website now?
            </p>

            <ul className="product-and-sol-list">
              <li>✔ Boost enrollment and marketing</li>
              <li>✔ Enhance engagement</li>
              <li>✔ Ensure compliance and accessibility</li>
              <li>✔ Adapt to hybrid learning models</li>
            </ul>

            <div
              className="read-more-btn"
              onClick={() => navigate("/dynamic-web/read-more")}
            >
              Read more →
            </div>
          </div>
        </div>

        {/* ===== SECTION 2 ===== */}
        <div className="product-and-sol-mainCard ps-two-column-grid product-sol-card">
          <div className="enrollment-image-card product-sol-card-imageBox">
            <img
              src="../images/product&soluction/academicmanagement.jpg"
              alt="Interactive School Website"
              className="ps-main-image"
            />
          </div>

          <div>
            <h2 className="product-and-sol-sectionTitle">
              Interactive & Real-Time Website
            </h2>
            <p className="product-and-sol-section-text">
              Publish announcements, academic calendars, events, and news while
              providing seamless access to SIS portals for parents, students,
              and staff.
            </p>

            <ul className="product-and-sol-list">
              <li>✔ Responsive & mobile-friendly design</li>
              <li>✔ Real-time content updates</li>
              <li>✔ Integrated SIS & portals</li>
              <li>✔ Events & news management</li>
            </ul>
          </div>
        </div>

        {/* ===== FEATURES ===== */}
        <div className="ps-feature-grid">

          <FeatureCard
            typeClass="credentialing"
            backgroundColor="#e9fdf3"
            icon={icons.responsive}
            title="Responsive Design"
            description="Adaptive layouts that work seamlessly on desktop, tablet, and mobile."
          />

          <FeatureCard
            typeClass="wallet"
            backgroundColor="#f3ecff"
            icon={icons.content}
            title="Dynamic Content Management"
            description="Update news, announcements, events, and calendars in real time."
          />

          <FeatureCard
            typeClass="human-resources"
            backgroundColor="#f1f6ff"
            icon={icons.portal}
            title="SIS & Portal Integration"
            description="Connect your website with SIS and parent/student portals."
          />

          <FeatureCard
            typeClass="education"
            backgroundColor="#fff3cc"
            icon={icons.events}
            title="Events & Announcements"
            description="Publish school events and important notifications instantly."
          />

          <FeatureCard
            typeClass="marketing"
            backgroundColor="#ffe6dc"
            icon={icons.gallery}
            title="Photo & Media Galleries"
            description="Showcase achievements and activities through rich media galleries."
          />

          <FeatureCard
            typeClass="analytics"
            backgroundColor="#eaf9fa"
            icon={icons.analytics}
            title="Visitor Insights"
            description="Analyze traffic, engagement, and popular content."
          />

        </div>

        {/* ===== CTA ===== */}
        <div className="ps-highlight-wrapper">
          <div className="ps-highlight-card">

            <div className="ps-highlight-header">
              <h2 className="ps-highlight-title">
                Modern, Engaging & Connected
              </h2>
              <p className="ps-highlight-subtitle">
                A digital presence that represents your institution
              </p>
            </div>

            <div className="ps-highlight-body">
              <p className="ps-highlight-text">
                Launch a professional, dynamic website that keeps your school
                community informed, engaged, and connected 24/7.
              </p>

              <div className="ps-button-group">
                <button className="Demo-button">
                  Request a Website Demo
                </button>
              </div>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
};

/* ===== SHARED FEATURE CARD ===== */
const FeatureCard = ({
  icon,
  title,
  description,
  backgroundColor,
  typeClass,
}) => (
  <div
    className={`card product-soluction-card ${typeClass}`}
    style={{ backgroundColor }}
  >
    <div className="card-overlay"></div>

    <div className="circle">
      <div className="ps-card-icon">{icon}</div>
    </div>

    <h3 className="ps-card-title">{title}</h3>
    <p className="product-soluction-card-text">{description}</p>
  </div>
);

/* ===== ICONS ===== */
const icons = {
  responsive: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <rect x="3" y="4" width="18" height="16" rx="2" stroke="#5a5cff" strokeWidth="2" />
      <path d="M3 10h18M3 14h18" stroke="#5a5cff" strokeWidth="2" />
    </svg>
  ),
  content: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <path d="M4 6h16M4 12h16M4 18h16" stroke="#ff8c00" strokeWidth="2" />
    </svg>
  ),
  portal: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <path d="M4 4h16v16H4z" stroke="#0ca85c" strokeWidth="2" />
      <path d="M8 4v16M16 4v16" stroke="#0ca85c" strokeWidth="2" />
    </svg>
  ),
  events: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <rect x="3" y="5" width="18" height="16" rx="2" stroke="#e74c3c" strokeWidth="2" />
      <path d="M3 9h18" stroke="#e74c3c" strokeWidth="2" />
    </svg>
  ),
  gallery: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <rect x="3" y="3" width="18" height="18" rx="2" stroke="#6c5ce7" strokeWidth="2" />
      <circle cx="8" cy="8" r="2" stroke="#6c5ce7" strokeWidth="2" />
      <path d="M21 21l-6-6-5 5-5-5-6 6" stroke="#6c5ce7" strokeWidth="2" />
    </svg>
  ),
  analytics: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <path d="M4 20V10M10 20V6M16 20v-4" stroke="#0097e6" strokeWidth="2" />
    </svg>
  ),
};

export default DynamicWebsiteForSchools;
